module.exports = __webpack_public_path__ + "img/r5c1.b8c574b7.jpg";